export function customSelect() {
  jcf.setOptions('Select', {
    wrapNative: false,
    maxVisibleItems:6
  });

  jcf.replaceAll();
}



// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js